export const FETCH_REGIONS_REQUEST = "meta/FETCH_REGIONS_REQUEST";
export const FETCH_REGIONS_SUCCESS = "meta/FETCH_REGIONS_SUCCESS";
export const FETCH_REGIONS_FAILURE = "meta/FETCH_REGIONS_FAILURE";
export const FETCH_HCP_TYPES_REQUEST = "meta/FETCH_HCP_TYPES_REQUEST";
export const FETCH_HCP_TYPES_SUCCESS = "meta/FETCH_HCP_TYPES_SUCCESS";
export const FETCH_HCP_TYPES_FAILURE = "meta/FETCH_HCP_TYPES_FAILURE";
export const GET_SPECIALITIES_REQUEST = 'GET_SPECIALITIES_REQUEST';
export const GET_SPECIALITIES_SUCCESS = 'GET_SPECIALITIES_SUCCESS';
export const GET_SPECIALITIES_FAILURE = 'GET_SPECIALITIES_FAILURE';
export const GET_FACILITY_DOCUMENTS = 'GET_FACILITY_DOCUMENTS';
export const SET_FACILITY_DOCUMENTS = "SET_FACILITY_DOCUMENTS";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const CLOSE_LOGIN_MODAL = "CLOSE_LOGIN_MODAL";
export const OPEN_SIGNUP_MODAL = "OPEN_SIGNUP_MODAL";
export const CLOSE_SIGNUP_MODAL = "CLOSE_SIGNUP_MODAL";
export const SET_LOGIN_VISIBLE = "SET_LOGIN_VISIBLE";
export const SET_SIGNUP_VISIBLE = "SET_SIGNUP_VISIBLE";
export const FETCH_CUSTOMERS_CONFIG_REQUEST = "FETCH_CUSTOMERS_CONFIG_REQUEST";
export const FETCH_CUSTOMERS_CONFIG_SUCCESS = "FETCH_CUSTOMERS_CONFIG_SUCCESS";
export const FETCH_CUSTOMERS_CONFIG_FAILURE = "FETCH_CUSTOMERS_CONFIG_FAILURE";


export const SET_THEME = 'SET_THEME';
export const TOGGLE_THEME = 'TOGGLE_THEME';



export const getFacilityDocuments = (facilityId: any) => {
    return {type: GET_FACILITY_DOCUMENTS, facilityId};
};
export const setFacilityDocuments = (documents: any[]) => ({type: SET_FACILITY_DOCUMENTS, payload: {documents}});
export const fetchRegionsRequest = () => ({type: FETCH_REGIONS_REQUEST});
export const fetchRegionsSuccess = (regions: any[]) => ({type: FETCH_REGIONS_SUCCESS, payload: {regions}});
export const fetchRegionsFailure = (error: any) => ({type: FETCH_REGIONS_FAILURE, payload: {error}});


export const fetchHcpTypeRequest = () => ({type: FETCH_HCP_TYPES_REQUEST});
export const fetchHcpTypeSuccess = (hcpTypes: any[]) => ({type: FETCH_HCP_TYPES_SUCCESS, payload: {hcpTypes}});
export const fetchHcpTypeFailure = (hcpTypeError: any) => ({type: FETCH_HCP_TYPES_FAILURE, payload: {hcpTypeError}});


export const getSpecialitiesRequest = () => ({type: GET_SPECIALITIES_REQUEST});

export const getSpecialitiesSuccess = (hcpSpecialitiesList: any[]) => ({
    type: GET_SPECIALITIES_SUCCESS,
    payload: hcpSpecialitiesList,
});

export const getSpecialitiesFailure = (hcpSpecialitiesError: any) => ({
    type: GET_SPECIALITIES_FAILURE,
    payload: hcpSpecialitiesError,
});

export const setTheme = (theme: 'light' | 'dark') => ({
    type: SET_THEME,
    payload: theme,
});

export const toggleTheme = () => ({
    type: TOGGLE_THEME,
});

export const setLoginModalVisible = (isVisible: boolean) => ({
    type: SET_LOGIN_VISIBLE,
    payload: isVisible,
});

export const setSignUpModalVisible = (isVisible: boolean) => ({
    type: SET_SIGNUP_VISIBLE,
    payload: isVisible,
});

export const fetchCustomersConfigRequest = () => ({type: FETCH_CUSTOMERS_CONFIG_REQUEST});
export const fetchCustomersConfigSuccess = (customersConfig:any) => ({
    type: FETCH_CUSTOMERS_CONFIG_SUCCESS,
    payload: {customersConfig}
});
export const fetchCustomersConfigFailure = (error:any) => ({
    type: FETCH_CUSTOMERS_CONFIG_FAILURE,
    payload: {error}
});



export const openModal = () => ({ type: OPEN_MODAL });
export const closeModal = () => ({ type: CLOSE_MODAL });

export const openLoginModal = () => ({ type: OPEN_LOGIN_MODAL });
export const closeLoginModal = () => ({ type: CLOSE_LOGIN_MODAL });

export const openSignUpModal = () => ({ type: OPEN_SIGNUP_MODAL });
export const closeSignUpModal = () => ({ type: CLOSE_SIGNUP_MODAL });